import { parseLocaleContent, type PartialLocaleContent } from '@guild/core'

import codeNames from '../../../../content/en/code-names.json'
import fragments from '../../../../content/en/fragments.json'
import guildVoice from '../../../../content/en/guild-voice.json'
import islandNames from '../../../../content/en/island-names.json'
import letterGrammar from '../../../../content/en/letter-grammar.json'
import logLines from '../../../../content/en/log-lines.json'
import manuscript from '../../../../content/en/manuscript.json'
import relics from '../../../../content/en/relics.json'

/**
 * The source locale, in the bundle.
 *
 * `en` is the floor every other locale falls back to per entry (Q12.5), so it
 * is the one locale that is never lazy: it is imported statically here and a
 * second locale becomes its own module beside this one, loaded on demand
 * (see `./index.ts`, #84).
 */
const en: PartialLocaleContent = parseLocaleContent(
  {
    fragments,
    'island-names': islandNames,
    'log-lines': logLines,
    'code-names': codeNames,
    'letter-grammar': letterGrammar,
    relics,
    'guild-voice': guildVoice,
    manuscript,
  },
  'en',
)

export default en
